var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import * as servicesActions from "./services.actions";
export var REDUCER_KEY_SERVICES = "services";
var getDefaultState = function () { return ({
    isReportingProblem: false,
    isAddingAttachment: false,
    reportProblemError: undefined,
    addAttachmentError: undefined,
    reportId: undefined,
}); };
var reducer = createReducer({}, getDefaultState());
reducer.on(servicesActions.reportProblem.types.START, function (state) { return (__assign(__assign({}, state), { isReportingProblem: true, reportProblemError: undefined, reportId: undefined })); });
reducer.on(servicesActions.reportProblem.types.SUCCESS, function (state, response) {
    return __assign(__assign({}, state), { isReportingProblem: false, reportProblemError: undefined, reportId: response.id });
});
reducer.on(servicesActions.reportProblemAddAttachment.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isAddingAttachment: false, reportProblemError: error, reportId: undefined }));
});
// eslint-disable-next-line import/no-default-export
export default reducer;
